/* eslint-disable */
import axios from 'axios';

export type AccessTokenProps = {
  code: number;
  payload: {
    response: string | object;
  };
};

export const getAccessToken = async(
  code: string,
): Promise<AccessTokenProps> => {
  const pingOneClientId = process.env.NEXT_PUBLIC_PING_CLIENT_ID;
  const redirect_uri = process.env.NEXT_PUBLIC_REDIRECT_API;
  const defiToken_api = `${ process.env.NEXT_PUBLIC_API_HOST }/v1/auth/token`;

  if (!code || !pingOneClientId || !redirect_uri || !defiToken_api) {
    return {
      code: 500,
      payload: {
        response: 'request is not properly strcutured or missing properties',
      },
    };
  }

  const requestData = {
    client_id: pingOneClientId,
    redirect_uri: redirect_uri,
    grant_type: 'authorization_code',
    code: code,
  };

  const requestHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };

  const formData = new URLSearchParams();
  Object.entries(requestData).forEach(([ key, value ]) => {
    formData.append(key, value);
  });

  const response = await axios.post(defiToken_api, formData, {
    headers: requestHeaders,
  });

  if (response?.data.status !== 'SUCCESS') {
    return {
      code: 500,
      payload: { response: response },
    };
  }

  return {
    code: 200,
    payload: { response: response.data.data.access_token },
  };
};
